import type React from "react";
import { useState } from "react";
import { Settings, Plus } from "lucide-react";
import InviteModal from "../../../../components/modals/InviteModal";
import { useNavigate } from "react-router-dom";
import type { InviteFormData } from "../../../../interface/interfaces";
import useApiHook from "../../../../utils/useApi";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import type { RootState } from "../../../../store";

const Tabs: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const navigate = useNavigate();

  const merchant = useSelector(
    (state: RootState) => state?.merchant?.permissions
  ) as string[] | undefined;

  const { makeRequest } = useApiHook("/dashboard/user/invite", {
    method: "post",
  });

  const hasPermission = (permission: string): boolean => {
    return Array.isArray(merchant) && merchant.includes(permission);
  };

  const canInviteUsers = hasPermission("CAN_INVITE_USERS");

  const handleInvite = async (formData: InviteFormData) => {
    const response = await makeRequest(formData);

    if (response?.status === 200 || response?.status === 201) {
      toast("User Invited Successfully");

      window.location.reload();
      setIsModalOpen(false);
    } else {
      toast.warning("User Invitation Failed");
    }
  };

  const handleManageRoles = () => {
    navigate("/dashboard/settings?tab=teams&mode=manage", { replace: true });
  };

  return (
    <>
      <div className="w-full flex flex-col sm:flex-row sm:justify-end items-center gap-3">
        <button
          className="w-full sm:w-auto flex items-center justify-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md transition-colors"
          onClick={handleManageRoles}
        >
          <Settings className="h-4 w-4" />
          <span>Manage roles</span>
        </button>

        {canInviteUsers && (
          <button
            className="w-full sm:w-auto flex items-center justify-center gap-2 px-4 py-2 bg-green-500 hover:bg-green-600 text-white rounded-md transition-colors"
            onClick={() => setIsModalOpen(true)}
          >
            <Plus className="h-4 w-4" />
            <span>Invite someone</span>
          </button>
        )}
      </div>

      <InviteModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleInvite}
      />
    </>
  );
};

export default Tabs;
